
 import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DatalayerService } from '../../../services/datalayer.service';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';




@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
  providers: [DatalayerService]
})
export class SigninComponent implements OnInit {

  CLIENT_ID:string; // ='966702354234-po6gblj1p2vnbpft7iesc2emmr2dnlf2.apps.googleusercontent.com';
  REDIRECT_URI:string ; //='https://pinnacleclient.azurewebsites.net/sessions/loading'



  @ViewChild(MatProgressBar) progressBar: MatProgressBar;
  @ViewChild(MatButton) submitButton: MatButton;
  @ViewChild(MatProgressSpinner) progressSpinner: MatProgressSpinner;

  Loading: boolean = false;

  signinData = {
    username: '',
    password: '',
    rememberMe: false
  }
  private values;
  private lsTested = false;
  returnValues = { error: false, message: '' };
  logoUrl: string;

  constructor(
    private dl: DatalayerService, 
    private router: Router,
    private authService: AuthService,
    public dialog: MatDialog, 
  ) {

    this.REDIRECT_URI=authService.redictUrl;
    this.CLIENT_ID = authService.googleClientID;
    window.localStorage.removeItem("Session");

    this.logoUrl = this.authService.logoUrl.getValue();
  }
  lsTest():boolean {
    var test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }
  ngOnInit() {
    this.dialog.closeAll();
    if(!this.lsTested){
    let ls = this.lsTest();
    this.lsTested=true;
    if(!ls){
      alert('Local Storage Not Supported!');
    } else {
      console.log('Local Storage Supported.');
    }

    }
    this.Loading = false;
    let objUser = window.localStorage.getItem("User");
    if (objUser) {
      let User = JSON.parse(objUser);
      if (User.rememberMe) {
        this.signinData.username = User.UserName;
        this.signinData.rememberMe = true;
      } else {
        window.localStorage.removeItem("User");
      }

    }

    // Temp
    // this.signinData.username = 'dmorris';
    // this.signinData.password = '1234';
    // this.signin()

  }

  login() {
    this.authService.login()
  }

  err(msg:string) {
    
    this.signinData.password = '';
    this.submitButton.disabled = false;
    this.progressBar.mode = 'determinate';
    this.progressBar.value = 0;
    this.Loading = false;
    let r = this.returnValues;
    r.error = true;
    
    if (msg == 'PASSWORD ERROR') {     
      r.message = 'Incorrect password'
      return false;
    }
    if (msg == 'USER NOT FOUND') {     
      r.message = 'This username was not found';
      return false;
    }
    if (msg == 'Server Timeout') {     
      r.message = 'Sorry, but the server didn\'t respond.';
      return false;
    }
  }
  signin() {

    //    this.router.navigate(['product-list'], { queryParams: { page: this.page + 1 } });

    // console.log(this.signinData);
    this.Loading = true;
    this.dl
      .Login(this.signinData.username, this.signinData.password)     
      .subscribe((data:any) => {

        this.signinData.password = '';
        this.submitButton.disabled = false;
        this.progressBar.mode = 'determinate';
        this.progressBar.value = 0;

        let r = this.returnValues;
        if (data.SessionId == 'USER NOT FOUND' || data.SessionId == 'PASSWORD ERROR') {
          this.err(data.SessionId)
          return false;
        }
       

        var expireSession = new Date();
        expireSession.setMinutes(expireSession.getMinutes() + 30);

        //Append the Remember-Me field to the user object and save it to the local storage
        data.rememberMe = this.signinData.rememberMe;
        let s = { sessionId: data.SessionId, expires: expireSession };

        console.log('placing session object into browser')
        let sessionString = JSON.stringify(s);
        window.localStorage.setItem("Session", sessionString);

        this.authService.currentUser = data;
        let stringData = JSON.stringify(data);
        window.localStorage.setItem("User", stringData);


        // this.router.navigateByUrl('/dashboard');
        this.Loading = false;
        this.authService.appEntryURL ? this.router.navigate([this.authService.appEntryURL]) : this.router.navigate(['/']);
        setTimeout(() => {
          console.log('Rerouting');
        }, 2000);
        return true
      }
      ,
      error => { this.submitButton.disabled = false; console.log(error) },
      () => console.log('Get all complete'));



    this.submitButton.disabled = true;
    this.progressBar.mode = 'indeterminate';
  }


  oauth2SignIn(isDev?) {
    localStorage.removeItem('chunkerRunTodayPST');
//https://console.developers.google.com/apis/credentials/consent/edit?project=dash-216521&duration=P1D
//https://console.developers.google.com/apis/credentials/oauthclient/966702354234-po6gblj1p2vnbpft7iesc2emmr2dnlf2.apps.googleusercontent.com?project=${your_project_number}
    if(isDev){
        this.REDIRECT_URI = "http://localhost:4200/sessions/loading"
        alert(this.REDIRECT_URI)
    }
    
    // Google's OAuth 2.0 endpoint for requesting an access token
    var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

    // Create element to open OAuth 2.0 endpoint in new window.
    var form = document.createElement('form');
    form.setAttribute('method', 'GET'); // Send as a GET request.
    form.setAttribute('action', oauth2Endpoint);
// sample scope: https://www.googleapis.com/auth/drive.metadata.readonly,
    // Parameters to pass to OAuth 2.0 endpoint.
    var params = {'client_id': this.CLIENT_ID,
                  'redirect_uri': this.REDIRECT_URI,
                  'scope':'openid email profile',
                  'state': 'dash_login',
                  'include_granted_scopes': 'true',
                  'response_type': 'id_token token',
                  'hd':'pinnaclepowersvcs.com',
                  'nonce': 'n-0S6_WzA2Mj'
                };

    // Add form parameters as hidden input values.
    for (var p in params) {
      var input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', p);
      input.setAttribute('value', params[p]);
      form.appendChild(input);
    }

    // Add form to page and submit it to open the OAuth 2.0 endpoint.
    document.body.appendChild(form);
    form.submit();

    this.authService.handleAuthentication_new();
  }
 


}
